import React from "react";
import { Toaster } from "react-hot-toast";
import Loader from "./Layouts/Loader/Loader";
import { useModalContext } from "./context/ModalContext";
import "./styles/Modal.css";
import { Tooltip } from "react-tooltip";
import AppRouter from "./routes/AppRouter";
import GlobalModals from "./components/GlobalModals/GlobalModals";
import { toastOptions } from "./utils/toastUtils";

const AppShell = () => {
  const { saveLoader } = useModalContext();
  return (
    <div>
      {saveLoader && (
        <div className="overlay">
          <Loader />
        </div>
      )}
      <AppRouter />
      <GlobalModals />
      <Toaster
        position="bottom-right"
        reverseOrder={true}
        toastOptions={toastOptions}
        containerStyle={{
          zIndex: 99999
        }}
      />
      <Tooltip id="builder-tooltip" style={{ fontWeight: 600, zIndex: 4333333 }} noArrow={true} />
    </div>
  );
};

export default AppShell;
